import { LicenseManagementViewController as controller } from './license-management-view-route.controller';
import template from './license-management-view-route.component.html';

export const licenseManagementViewRoute = {
	controller,
	template
};
